import { Component} from '@angular/core';
 
@Component({
    selector: 'app-requerimentodebeneficio',
    templateUrl: './requerimentodebeneficio.component.html',
    styleUrls: ['./requerimentodebeneficio.component.scss']
})


export class requerimentodebeneficioComponent {}